import { render, staticRenderFns } from "./SeriesPointsScheaduleTbl.vue?vue&type=template&id=b645bbe2&scoped=true&"
import script from "./SeriesPointsScheaduleTbl.vue?vue&type=script&lang=js&"
export * from "./SeriesPointsScheaduleTbl.vue?vue&type=script&lang=js&"
import style0 from "./SeriesPointsScheaduleTbl.vue?vue&type=style&index=0&id=b645bbe2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b645bbe2",
  null
  
)

export default component.exports